import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
  close: {
    id: `close`,
  },
});
